export const buildPagination = (currentPage, totalPages) => {
    let pagesToShow = [];

    if (currentPage > 3) pagesToShow.push(currentPage - 2)
    if (currentPage > 2) pagesToShow.push(currentPage - 1)
    if (currentPage != 1) pagesToShow.push(currentPage)

    if ((currentPage + 1) < totalPages) {
        pagesToShow.push(currentPage + 1)
    }

    return pagesToShow
}
